import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { COMPANY } from "../../lib/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why Maddox", href: "#manifesto" },
  { label: "Service Area", href: "#area" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex h-20 items-center justify-between">
          <a href="#top" data-testid="nav-logo" className="flex items-center">
            <img src={COMPANY.logo} alt="Maddox Heating and Cooling" className="h-14 w-auto object-contain md:h-16" />
          </a>

          <nav className="hidden items-center gap-9 md:flex">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="font-mono-tech text-xs uppercase tracking-[0.15em] text-muted-foreground transition-colors hover:text-foreground"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <a
            href={COMPANY.phoneHref}
            data-testid="nav-call-btn"
            className="hidden items-center gap-2 bg-primary px-5 py-3 font-mono-tech text-xs font-bold uppercase tracking-[0.15em] text-primary-foreground transition-colors hover:bg-white hover:text-black md:flex"
          >
            <Phone className="h-4 w-4" /> {COMPANY.phone}
          </a>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden text-foreground"
            aria-label="Menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-black/95 md:hidden" data-testid="mobile-menu">
          <div className="flex flex-col px-5 py-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="border-b border-white/5 py-4 font-mono-tech text-sm uppercase tracking-[0.15em] text-muted-foreground"
              >
                {l.label}
              </a>
            ))}
            <a
              href={COMPANY.phoneHref}
              className="mt-4 flex items-center justify-center gap-2 bg-primary py-4 font-mono-tech text-sm font-bold uppercase text-primary-foreground"
            >
              <Phone className="h-4 w-4" /> Call {COMPANY.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
